export default "__VITE_ASSET__CPp7Xqqu__"